"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import MyGame from "../game/MyGame";
import Tutorial from "../game/Tutorial";
import MenuPanel from "../ui/overlays/MenuPanel";
import PalettePanel from "../ui/overlays/PalettePanel";
import PaletteButton from "../game/PaletteButton";
import SimpleScene  from "./SimpleScene";

export default class GameScene extends SimpleScene {
    constructor() {
        super();

        // Attributes.
        this._menuPanel = null;
        this._tutorial = null;

        this._gameLayer = null;
        this._tutorialLayer = null;
        this._overlayLayer = null;
    }

    init() {

        this._bgSprite = new PIXI.Sprite(Common.assets.getTexture("bg"));//not sure why this is like this, but must create background first
        super.init();

        // Layers.
        this._gameLayer = new PIXI.Container();
        this.addChild(this._gameLayer);
        this._tutorialLayer = new PIXI.Container();
        this.addChild(this._tutorialLayer);
        this._overlayLayer = new PIXI.Container();
        this.addChild(this._overlayLayer);

        // Overlay initialization. Order is important due to dependencies.
        // Menu.
        this._menuPanel = new MenuPanel(this.signals);
        this._menuPanel.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5);
        this._menuPanel.init();
        this._overlayLayer.addChild(this._menuPanel);

        // Palette.
        this._palettePanel = new PalettePanel();
        this._palettePanel.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5);
        this._palettePanel.init();
        this._overlayLayer.addChild(this._palettePanel);

        // Game.
        Common.game = new MyGame();
        Common.game.scene = this;
        Common.game.init();

        // Tutorial.
        if (Common.savedData.isDrawTutorial || Common.savedData.isToolTutorial || Common.savedData.isPaletteTutorial) {
            this._tutorial = new Tutorial();
            this._tutorial.init();
            this._tutorial.signals.onCompleted.addOnce(
                function () {
                    this._tutorial.end();
                    this._tutorial.destroy();
                    this._tutorial = null;
                },
                this);
            this._tutorialLayer.addChild(this._tutorial);
        }

        // Signals.
        // Link the panels to the HUD buttons that show them.
        Common.game.hud.signals.onMenuClick.add(this._onMenuBtn_Click, this);
        Common.game.hud.signals.onPaletteClick.add(this._onPaletteBtn_Click, this);

        this.createSharedControls();
    }

    update() {
        if (this._tutorial) this._tutorial.update();
        Common.game.update();
    }

    animateIn() {
        // Music.
        Common.audio.stopMusic();
        Common.audio.playMusic("sfx_ambient_desert_loop_00");

        Common.game.animateIn();
    }

    resize() {
        this.x = ( P3.View.width - Common.STAGE_WIDTH ) * 0.5;

        Common.game.resize();
        if (this._tutorial) this._tutorial.resize();
    }

    addTutorialEvent(tutorialEvent) {
        if (this._tutorial) this._tutorial.addEvent(tutorialEvent);
    }

    //----EVENTS----//

    _onMenuBtn_Click() {
        this._menuPanel.show();
    }

    _onPaletteBtn_Click(toolType) {
        // Show palette panel.
        this._palettePanel.show(toolType);

        // Tutorial.
        Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.PALETTE_SELECTED);
    }

    get gameLayer() {
        return this._gameLayer;
    }

    get palettePanel() {
        return this._palettePanel;
    }
}
